import React, { useContext, useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
    Spinner,
    Modal
} from "reactstrap";

// core components
import LoggedinHeader from "../components/Headers/LoggedinHeader.js";
import LoggedinNavbar from "../components/Navbars/LoggedinNavbar.js";
import LoggedinFooter from "../components/Footers/LoggedinFooter.js";
import { AuthContext } from '../AuthContext';
import { AxiosContext } from '../AxiosContext';
import { AnimatePresence, motion } from "framer-motion";
import HomeSkeleton from "../skeleton-screens/HomeSkeleton";
import ADModal from '../components/ADModal';
import { State }  from "country-state-city";
import Select from 'react-select';

function MyCartBal() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { adid } = state;
    const auth = useContext(AuthContext);
    const { authAxios } = useContext(AxiosContext);
    const [isLoading, setIsLoading] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);

    const [discMsg, setDiscMsg] = useState('');
    const [usrStateMsg, setUsrStateMsg] = useState('');
    const [discountcode, setDiscountcode] = useState(''),
        onDiscountInput = ({ target: { value } }) => setDiscountcode(value);
    const [gstin, setGstin] = useState(''),
        onGstinInput = ({ target: { value } }) => setGstin(value);
    const [usrstate, setUsrstate] = useState(''),
        onStateInput = (value) => setUsrstate(value);
    const [adDetails, setAdDetails] = useState([]);
    const [discDetails, setDiscDetails] = useState([]);
    const [payHalf, setPayHalf] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);


    document.documentElement.classList.remove("nav-open");
    React.useEffect(() => {
        document.body.classList.add("CreateAd-page");
        return function cleanup() {
            document.body.classList.remove("CreateAd-page");
        };
    });


    const renderSpinner = () => {
        if (showSpinner) {
            return (
                <Modal isOpen={showSpinner} centered={true} className="spinnerModal">
                    <div className="modal-body">
                        <Spinner color="primary">
                            Loading...
                        </Spinner>
                    </div>
                </Modal>

            );
        }
    };
    const showModal = (msg) => {
        setModalMsg(msg);
        setIsModalVisible(!isModalVisible);
    };

    const handleModal = () => showModal('');

    const renderOkButton = () => {
        return (
            <Button
                className="btn-round"
                color="primary"
                type="button"
                onClick={() => handleModal()}
            >
                <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;&nbsp; ok &nbsp;&nbsp;</span>
            </Button>
        );
    };

    const renderCurrency = (currency) => {
        if (currency == 'INR') {
            return <>&#8377;</>;
        } else {
            return <></>;
        }
    };

    const renderTax = (cost, tax, designcost) => {
        if (tax) {
            let taxp = 0;
            let newtaxp = 0;
            if (designcost > 0) {
                newtaxp = cost + designcost;
                taxp = newtaxp * (tax / 100);
            } else {
                taxp = cost * (tax / 100);
            }
            //console.log("XXX111: " + taxp);
            return taxp.toFixed(2);
        } else {
            return '0';
        }
    };

    const renderTotal = (cost, tax, designcost) => {
        if (tax) {
            let tot = 0;
            let newtot = 0;
            let taxp = 0;
            if (designcost > 0) {
                newtot = cost + designcost;
                tot = newtot + (newtot * (tax / 100));
            } else {
                taxp = cost * (tax / 100);
                tot = cost + taxp;
            }
            return tot.toFixed(2);;
        } else {
            if (designcost > 0) {
                return cost + designcost;
            } else {
                return cost;
            }

        }
    };

    const renderDesignCost = () => {
        if (adDetails.designcost > 0) {
            return (
                <div className="myCartField">
                    <div className="myCartLeft">Design cost: </div>
                    <div className="myCartRight">{renderCurrency(adDetails.currency)} {adDetails.designcost} </div>
                </div>
            );
        }

    }

    const renderDesignCostNote = () => {
        if (adDetails.designcost > 0) {
            return (<span style={{ color: '#767676', textTransform: 'none' }}>* discounts do not apply on design cost</span>);
        }
    }

   

    const triggerPayment = async () => {
        try {
            
                setShowSpinner(true);
                if (adDetails && adDetails.paidtype == 'half' && (adDetails.balance && adDetails.balance > 0)) {
                    
                    navigate('/paymentcf', { state: { adid: adid, paymentType: 'remhalf' } });
                    
                } else {
                    throw 'Server error. Please start over';
                }
                       

        } catch (error) {
            setShowSpinner(false);
            if (typeof error.message === 'undefined') {
                showModal(error);
            } else {
                showModal(error.message);
            }
        }        
    }

    const fetchData = async () => {
        
        if (adid) {
            try {
                setIsLoading(true);
                let url = '/ad/' + adid;
                const response = await authAxios.get(url);
                var responseData = '';
                let result = response.data;
                let designid = null;
                if (result.data) {
                    setAdDetails(result.data);
                } else {
                    throw "Server error. Unable to fetch data";
                }
                setIsLoading(false);
            } catch (error) {
                showModal(error);
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    return (
        <>
            <LoggedinHeader />
            <LoggedinNavbar />
            <AnimatePresence>
                <div className="main">
                    <div className="text-center">
                        {isLoading && (
                            <Container>
                                <HomeSkeleton exit={{ opacity: 0 }} />
                            </Container>
                        )}
                        <Container>
                            <Row>
                                {!isLoading && (
                                    <Col className="ml-auto mr-auto">
                                        <Card className="card-register">
                                            <h3 className="title mycartHeader">{adDetails.name}</h3>
                                            <div className="myCartContainer">
                                                <div className="myCartField">
                                                    <div className="myCartLeft">Campaign cost: </div>
                                                    <div className="myCartRight">{renderCurrency(adDetails.currency)} {adDetails?.discountcost ? adDetails?.discountcost : adDetails.cost} </div>
                                                </div>
                                                {renderDesignCost()}
                                                <div className="myCartField">
                                                    <div className="myCartLeft">{adDetails.taxtype} ({adDetails.tax}%) :</div>
                                                    <div className="myCartRight">{renderCurrency(adDetails.currency)} {renderTax(parseFloat(adDetails?.discountcost ? adDetails?.discountcost : adDetails.cost), parseFloat(adDetails.tax), parseFloat(adDetails.designcost))}</div>
                                                </div>
                                                <div className="myCartField">
                                                    <div className="myCartLeft">Total :</div>
                                                    <div className="myCartRight">{renderCurrency(adDetails.currency)} {renderTotal(parseFloat(adDetails?.discountcost ? adDetails?.discountcost : adDetails.cost), parseFloat(adDetails.tax), parseFloat(adDetails.designcost)).toString()}</div>
                                                </div>
                                                <div className="myCartField">
                                                    <div className="myCartLeft">Paid :</div>
                                                    <div className="myCartRight">{renderCurrency(adDetails.currency)} {adDetails.balance}</div>
                                                </div>
                                                <div className="myCartField">
                                                    <div className="myCartLeft">Balance to pay :</div>
                                                    <div className="myCartRight">{renderCurrency(adDetails.currency)} {adDetails.balance}</div>
                                                    </div>
                                            </div>
                                            
                                            <div className="myCartPay">
                                               <Button
                                                    className="btn-round"
                                                    color="primary"
                                                    onClick={() => triggerPayment()}
                                                >
                                                    <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Pay now&nbsp;</span>
                                                </Button>
                                            </div>
                                            
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                        </Container>
                    </div>
                    <ADModal
                        isVisible={isModalVisible}
                        msg={modalMsg}
                        children={renderOkButton()}
                    />
                    {renderSpinner()}

                </div>
            </AnimatePresence>
            <LoggedinFooter />

        </>
    );
}

export default MyCartBal;
